import { store } from '@/firebase'
import { FormulaUser } from '@/helpers/fs/formulaUser'
import {
  CollectionName,
  FSCalendar,
  OauthServiceName
} from '@WombatTechnology/nitte-time-lib'
import {
  collection,
  CollectionReference,
  doc,
  DocumentData
} from 'firebase/firestore'
export class Calendar {
  static doc(
    uid: string,
    service: OauthServiceName,
    accountId: string,
    calendarId: string
  ) {
    return doc<FSCalendar, DocumentData>(
      this.collection(uid, service, accountId),
      calendarId
    )
  }

  static collection(
    uid: string,
    serviceName: OauthServiceName,
    accountId: string
  ) {
    return collection(
      store,
      `${CollectionName.Users}/${uid}/${CollectionName.AuthorizedServices}/${serviceName}/${CollectionName.AuthorizedServicesAccounts}/${accountId}/${CollectionName.Calendars}`
    ) as CollectionReference<FSCalendar>
  }

  static toFormulaUser(calendar: FSCalendar): FormulaUser {
    const { id, title, accountId, color } = calendar
    return {
      id,
      name: title,
      email: id,
      type: 'calendar',
      accountId,
      color,
      authorizedServices: [],
      plan: 'free'
    }
  }
}
